import axios from 'axios';
import {getDataOptions, postDataOptions} from './backendServices';
import {BASE_URL} from './environments';

const Api = {
    get: async (url, baseUrl) => {
        const _baseUrl = baseUrl || BASE_URL;
        try {
            const response = await axios(getDataOptions(_baseUrl, url));
            return response.data;
        } catch (error) {
            return Promise.reject(error);
        }
    },
    post: async (url, data, baseUrl, isFormData = false, customAccessToken) => {
        const _baseUrl = baseUrl || BASE_URL;
        try {
            const response = await axios(postDataOptions(_baseUrl, url, data, isFormData, customAccessToken));
            return response.data;
        } catch (error) {
            return Promise.reject(error);
        }
    },
};

export default Api;
